// src/pages/Predicciones.jsx
import React, { useState, useEffect } from 'react';
import api from '../api/api';
import ClientLayout from '../components/ClientLayout'; // 🆕 Importar Layout
import { useNavigate } from 'react-router-dom';

function Predicciones() {
    const navigate = useNavigate();
    const [predicciones, setPredicciones] = useState([]);
    const [loading, setLoading] = useState(true);

    // Estados para el filtro de fecha
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');

    // --- COLORES XAVANA ---
    const COLOR_SIERRA_GREEN = '#2E5B2E'; 
    const COLOR_CANTERA_PINK = '#C19A6B'; 
    const COLOR_SOFT_CREAM = '#F9F9F5';
    const COLOR_CHARCOAL = '#333333';
    const COLOR_WHITE = '#FFFFFF';

useEffect(() => {
        const fetchPredicciones = async () => {
            const token = localStorage.getItem('token');
            if (!token) return;
            try {
                const response = await api.get('/predicciones/me', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // CAMBIO AQUÍ: Ordenar por fecha ASCENDENTE (a - b)
                // Esto pone las fechas más cercanas al principio y las lejanas al final.
                setPredicciones(response.data.sort((a, b) => new Date(a.fecha) - new Date(b.fecha))); 
                
            } catch (error) {
                console.error("Error cargando predicciones", error);
            } finally {
                setLoading(false);
            }
        };
        fetchPredicciones();
    }, [navigate]);

    // Lógica de filtrado (se mantiene)
    const prediccionesFiltradas = predicciones.filter(p => {
        if (!fechaInicio && !fechaFin) return true;
        const fechaPrediccion = new Date(p.fecha).getTime();
        const inicio = fechaInicio ? new Date(fechaInicio).getTime() : -Infinity;
        // Ajustar fin para incluir el día completo
        const fin = fechaFin ? new Date(fechaFin + 'T23:59:59').getTime() : Infinity;
        return fechaPrediccion >= inicio && fechaPrediccion <= fin;
    });

    // --- Estilos Adaptados al Tema Xavana Café ---
    const containerStyle = {
        width: '100%',
        maxWidth: 800,
        padding: 30,
        background: COLOR_WHITE, // Fondo de tarjeta blanco
        borderRadius: 12,
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        color: COLOR_CHARCOAL,
    };
    
    // Estilos del filtro mejorados 
    const filterContainerStyle = { 
        width: '100%', 
        marginBottom: 25, 
        display: 'flex', 
        gap: 15, 
        justifyContent: 'center', 
        background: COLOR_SOFT_CREAM, // Fondo Soft Cream para el filtro
        padding: 15, 
        borderRadius: 12, 
        border: `1px solid ${COLOR_CANTERA_PINK}` // Borde Cantera Pink
    };
    
    const inputStyle = { 
        padding: 8, 
        borderRadius: 5, 
        border: `1px solid ${COLOR_CANTERA_PINK}`,
        background: COLOR_WHITE,
        color: COLOR_CHARCOAL
    };
    
    // Estilo para cada item de predicción (como tarjeta)
    const itemStyle = {
        width: '100%', 
        background: COLOR_SOFT_CREAM, // Fondo Soft Cream
        marginBottom: 12, 
        padding: 18, 
        borderRadius: 10, 
        borderLeft: `4px solid ${COLOR_SIERRA_GREEN}`, // Borde Verde Sierra
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        transition: 'box-shadow 0.2s',
        boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
    };
    
    const labelStyle = { fontSize: 12, fontWeight: 'bold', marginBottom: 2, color: COLOR_CHARCOAL };
    
    const clearButtonStyle = { 
        marginTop: 22, 
        padding: '8px 15px', 
        background: COLOR_CANTERA_PINK, // Botón Cantera Pink
        border: 'none', 
        borderRadius: 6, 
        cursor: 'pointer', 
        fontWeight: 'bold', 
        color: COLOR_WHITE 
    };

    return (
        <ClientLayout title="Predicciones de Demanda">
            <div style={containerStyle}>
                <h3 style={{ color: COLOR_SIERRA_GREEN, borderBottom: `1px solid ${COLOR_SOFT_CREAM}`, paddingBottom: 10, margin: '0 0 20px 0' }}>
                    Tus Predicciones de Consumo Futuro
                </h3>
                
                {/* Controles de Filtro */}
                <div style={filterContainerStyle}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label style={labelStyle}>Desde:</label>
                        <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} style={inputStyle} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label style={labelStyle}>Hasta:</label>
                        <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} style={inputStyle} />
                    </div>
                    <button 
                        onClick={() => { setFechaInicio(''); setFechaFin(''); }} 
                        style={clearButtonStyle}
                    >
                        Limpiar
                    </button>
                </div>
                {/* Lista de Predicciones */}
                {loading ? (
                    <p style={{textAlign: 'center'}}>Cargando predicciones...</p>
                ) : prediccionesFiltradas.length === 0 ? (
                    <p style={{textAlign: 'center'}}>No se encontraron predicciones en este rango.</p>
                ) : (
                    <div style={{ width: '100%', overflowY: 'auto', maxHeight: 500, marginTop: 10 }}>
                        {prediccionesFiltradas.map((pred) => (
                            <div key={pred.id} style={itemStyle} onMouseEnter={e => e.currentTarget.style.boxShadow = `0 0 10px ${COLOR_SIERRA_GREEN}30`} onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.05)'}>
                                <div>
                                    <div style={{ fontWeight: 'bold', color: COLOR_SIERRA_GREEN, fontSize: 18 }}>
                                        Fecha Sugerida: {new Date(pred.fecha).toLocaleDateString()}
                                    </div>
                                    <div style={{ fontSize: 14, color: COLOR_CHARCOAL, marginTop: 5 }}>
                                        Cantidad estimada: <strong style={{color: COLOR_CANTERA_PINK}}>{pred.cantidad} Kg</strong>
                                    </div>
                                </div>
                                
                                <div style={{textAlign: 'right'}}>
                                    {pred.asociadaAPedido && (
                                        <span style={{ background: `${COLOR_SIERRA_GREEN}20`, color: COLOR_SIERRA_GREEN, padding: '4px 10px', borderRadius: 15, fontSize: 12, fontWeight: 'bold' }}>
                                            ✅ Pedido Realizado
                                        </span>
                                    )}
                                    {!pred.asociadaAPedido && (
                                        <span style={{ background: `${COLOR_CANTERA_PINK}30`, color: COLOR_CHARCOAL, padding: '4px 10px', borderRadius: 15, fontSize: 12, fontWeight: 'bold' }}>
                                            ⏳ Pendiente de Pedido
                                        </span>
                                    )}
                                    <div style={{fontSize: 11, color: COLOR_CHARCOAL, marginTop: 5}}>
                                        ID Predicción: {pred.id.slice(-5)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </ClientLayout>
    );
}

export default Predicciones;